import { openContextModal } from "@mantine/modals";

import { ModalInnerProps } from "./StripeCheckoutModal.tsx";

/**
 * Проверяет, является ли устройство мобильным по ширине экрана.
 */
const checkIsMobile = (): boolean => {
	if (typeof window === "undefined") return false;
	return window.matchMedia("(max-width: 50em)").matches;
};

/**
 * Открывает модалку Stripe Checkout.
 * На мобильных устройствах модалка открывается в fullscreen режиме.
 */
export const openStripeCheckoutModal = (params: ModalInnerProps & { onClose?: () => void }) => {
	const { onClose, ...innerProps } = params;
	const isMobile = checkIsMobile();

	openContextModal({
		modal: "stripeCheckoutModal",
		onClose,
		innerProps: innerProps,
		// Убираем заголовок модалки - кнопка закрытия внутри компонента
		withCloseButton: false,
		padding: 0,
		size: isMobile ? "100%" : 400,
		fullScreen: isMobile,
		// Для fullscreen лучше использовать fade transition
		transitionProps: isMobile ? { transition: "fade", duration: 200 } : undefined
	});
};
